package org.catharsis.spendtel.feature.legal

enum class LegalDocumentType {
    PrivacyPolicy,
    TermsAndConditions,
}

data class LegalSection(
    val title: String,
    val paragraphs: List<String>,
    val bullets: List<String> = emptyList(),
)

data class LegalDocument(
    val type: LegalDocumentType,
    val title: String,
    val subtitle: String,
    val lastUpdated: String,
    val sections: List<LegalSection>,
)
